import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { BesichtigungsStatiService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [BesichtigungsStatiService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class BesichtigungsStatiServiceModule {}
